import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Card, Grid, Typography } from "@mui/material";
import { theme } from "@/components/Elements/theme";
import HomeScreenImg from "@/assets/earth.jpg";
import Header from "@/components/Elements/header";
import HeaderValue from "@/components/Elements/headerMain";
import Footer from "@/components/Elements/footer";
import { useAuth } from "@/lib/auth";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(1),
  },
  paperClass: {
    padding: theme.spacing(2),
    textAlign: "center",
    background: "rgba(5, 5, 24, 0.8)",
    borderRadius: "10px",
  },
  myGridItem: {
    backgroundColor: "rgba(5, 5, 24, 0.8)",
    padding: "30px",
    borderRadius: "20px",
  },
  innerGrid: {
    backgroundColor: "#050518",
    padding: "10px",
    borderRadius: "20px",
  },
  cardRoot: {
    background: "rgba(5, 5, 24, 0.25)",
    boxShadow: "0px 2.81226px 28.1226px 7.03066px rgba(0, 0, 0, 0.03)",
    borderRadius: "10px",
  },
  content: {
    // maxWidth: "700px",
    color: "white",
    textAlign: "start",
    "& h1, & h2": {
      color: "#3C37FF",
    },
    "& p, & ul, & ol": {
      color: "white",
      fontSize: { xs: "12px", sm: "14px", md: "16px" },
      opacity: "0.7",
      fontWeight: 400,
      lineHeight: { xs: 1.3, md: 1.5 },
    },
    "& ul, & ol": {
      margin: "10px 0",
      paddingLeft: "20px",
    },
    "& ul ul, & ul ol, & ol ul, & ol ol": {
      paddingLeft: "20px",
    },
  },
  sizee: {
    "@media (min-width: 0px)": {
      fontSize: "12px",
    },
    "@media (min-width: 676px)": {
      fontSize: "14px",
    },
    "@media (min-width: 992px)": {
      fontSize: "16px",
    },
    opacity: "0.7",
    fontWeight: 400,
    lineHeight: "150%",
    color: "white",
  },
}));

export default function AMLPolicy() {
  const classes = useStyles();
  const auth = useAuth();

  return (
    <>
      {auth.user ? <Header /> : <HeaderValue />}
      <Box
        sx={{
          background: `linear-gradient(89.41deg, #1B1C2D 7.81%, rgba(27, 28, 45, 0) 38.09%), linear-gradient(1.53deg, #1B1C2D 13.32%, rgba(27, 28, 45, 0) 50.41%), linear-gradient(46.49deg, #1B1C2D 14.7%, rgba(27, 28, 45, 0) 43.39%), url(${HomeScreenImg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          minHeight: "100%",
          backgroundAttachment: "fixed",
          backgroundPosition: "center",
          padding: {
            xs: "10px 0",
            lg: "100px 0px 20px",
          },
        }}
      >
        <Box
          sx={{
            p: { xs: "0 15px" },
            maxWidth: "95%",
            width: "100%",
            margin: "0 auto",
          }}
        >
          <Box
            sx={{
              backgroundColor: "rgba(5, 5, 24, 0.8)",
              borderRadius: "10px",
              display: "flex",
              flexFlow: "column",
              marginTop: {
                xs: "10px",
                md: "10px",
                lg: "0px",
              },
              p: { xs: "20px 15px", sm: "25px 20px", md: "30px 25px" },
            }}
          >
            <Typography
              component={"h1"}
              sx={{
                fontSize: { xs: "18px", md: "20px", lg: "23px" },
                fontWeight: 500,
                color: "#3C37FF",
                marginTop: "0px",
                marginBottom: {
                  xs: "5px",
                  md: "10px",
                },
              }}
            >
              AML Policy
            </Typography>
            <Grid
              container
              display={"flex"}
              direction={"row"}
              spacing={2}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Grid item xs={12}>
                <Card sx={{ margin: "0 auto", background: "none" }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      height: {
                        xs: "calc(100vh - 180px)",
                        sm: "calc(100vh - 200px)",
                        lg: "calc(100vh - 300px)",
                      },
                      margin: "auto",
                      overflow: "auto",
                    }}
                  >
                    <div className={classes.content}>
                      <h2 className={classes.sizee}>1. Anti-Money Laundering Policy</h2>
                      <p className={classes.sizee}>
                        As part of our commitment to conducting business ethically and maintaining the highest standards of integrity, MERVCF Limited has adopted a zero-tolerance policy on money laundering. Money laundering is a serious crime that can damage the integrity of our business and have harmful consequences for society as a whole.
                      </p>
                      <h3 className={classes.sizee}>Measures to prevent money laundering</h3>
                      <ul>
                        <li className={classes.sizee}>Identification and verification of participants: We will operate a robust system for identifying and verifying participants in our lottery, requiring relevant IDs and documentation.</li>
                        <li className={classes.sizee}>Transaction Monitoring: We will carefully monitor and analyze all transactions to identify suspicious activity.</li>
                        <li className={classes.sizee}>Education and awareness: Staff will be trained to recognize and report suspicious activity.</li>
                        <li className={classes.sizee}>Cooperation with Law Enforcement: We will comply with all legal requirements and cooperate with authorities.</li>
                        <li className={classes.sizee}>Periodic Review: We will regularly review and revise our AML policies.</li>
                      </ul>
                      <p className={classes.sizee}>Each player can buy a maximum of 100 tickets in each lottery.</p>

                      <h2 className={classes.sizee}>2. Company Policy Statement</h2>
                      <p className={classes.sizee}>
                        MervCF Limited is not a financial institution within the meaning of applicable law of Costa Rica and is accordingly not directly subject to the statutes and regulations applicable to certain financial institutions, money transfer, or virtual asset service providers. However, in accordance with the 2016 Regulations for Anti-Money Laundering and Combating the Financing of Terrorism (“AML/CFT”) applicable for the Costa Rica jurisdiction, MervCF Limited11 expressly prohibits and rejects the use of MervCF Limited products for any form of illicit activity, including money laundering, terrorist financing or trade sanctions violations, consistent with various national anti-money laundering (“AML”) laws, regulations and norms. MervCF Limited continues to monitor norm setting parameters promulgated by the Financial Action Task Force (“FATF”) and certain gaming trade groups in addition to the Costa Rica Gaming Control Board and will take necessary action as it deems appropriate to reflect changes in law.
                      </p>
                      <p className={classes.sizee}>
                        MervCF Limited’s intention is to follow global best practices in guarding against MervCF Limited products being used to facilitate such activities. Those best practices include:

                      </p>
                      <ul>
                        <li className={classes.sizee}>Adoption of a written policy, and procedures and controls, reasonably designed to guard against money laundering, terrorist financing and trade sanctions violations;
                        </li>
                        <li className={classes.sizee}>Where appropriate, designation of a compliance officer to oversee the implementation of the policy, procedures and controls;
                        </li>
                        <li className={classes.sizee}>Provision of related education and training to relevant personnel; and
                        </li>
                        <li className={classes.sizee}>Independent reviews, monitoring and maintenance of the policy, procedures and controls.
                        </li>
                      </ul>
                      <h2 className={classes.sizee}>3. Definitions

                      </h2>
                      <p className={classes.sizee}>
                        The following defined terms are widely used in the industry:
                        Money Laundering: The process of making illegally-gained proceeds appear legal. This process is generally broken down into three steps: placement, layering and integration.
                        Placement: The process of placing unlawful proceeds into traditional financial institutions, through deposits or other avenues.
                        Layering: The process of separating proceeds of criminal activity from their origin through the use of layers of complex financial transactions, such as converting cash into traveler’s checks, money orders, wire transfers, letters of credit, stocks, bonds or purchasing assets.
                        Integration: Using apparently legitimate transactions to disguise the illicit proceeds, allowing the laundered funds to be distributed back to the criminal; integrating the now clean money back into normal use.
                        Suspicious Activity: Activity conducted by a user or non-user using the institution where there are indications that the persons engaging in the transaction may be doing so for fraudulent or illegal purposes.


                      </p>
                      <p className={classes.sizee}>
                        Sanctions: Sanctions are activities conducted by the international community to prohibit or constrain activities of the target of the sanctions.For example, they are used:

                      </p>
                      <ul>
                        <li className={classes.sizee}>To encourage a change in behaviour for a target country or regime;

                        </li>
                        <li className={classes.sizee}>To apply pressure on a target country to comply with set objectives;

                        </li>
                        <li className={classes.sizee}>As an enforcement tool when international peace and security has been threatened and diplomatic efforts have failed; or

                        </li>
                        <li className={classes.sizee}>To prevent and suppress the financing of terrorists or terrorist acts.

                        </li>
                      </ul>
                      <h2 className={classes.sizee}>4. Governance and Oversight
                      </h2>
                      <p className={classes.sizee}>
                        MervCF Limited has appointed a Chief Compliance Officer (“CCO”) that is responsible for coordinating the implementation of the AML Policy and policy program. The Chief Compliance Officer’s duties also include developing AML initiatives, work with other MervCF Limitedholders to revising the AML policy, assessing new regulatory requirements and investigate potentially suspicious or unusual activity. MervCF Limited also provides AML training to all of its employees on a regular basis.


                      </p>
                      <h2 className={classes.sizee}>5. Know Your Customer and Transaction Monitoring
                      </h2>
                      <p className={classes.sizee}>
                        MervCF Limited will apply appropriate user due diligence and ongoing monitoring measures required by law. MervCF Limited will endeavour to prevent users from engaging in illicit or otherwise unauthorised activity. MervCF Limited uses a combination of its software development and other service agreements, which are enforced through internal operational features to ensure that it complies with the applicable law.



                      </p>
                      <h2 className={classes.sizee}>Know Your Customer

                      </h2>
                      <p className={classes.sizee}>
                        A. Customer Due Diligence.
                        MervCF Limited has adopted a risk based CDD to enable MervCF Limited to understand the nature and purpose of the user relationship to the MervCF Limited platform in order to develop a customer risk profile. In order to do so, MervCF Limited collects certain documentary and non-documentary information at account-opening commensurate with the nature of the type account and services that MervCF Limited offers. MervCF Limited maintains different CDD for different accounts and services.
                        For instance, the CDD requires users go through MervCF Limited’s customer identification program (“CIP”). The CIP consists of procedures for:


                      </p>
                      <ul>
                        <li className={classes.sizee}>Collecting baseline (e.g., wallet address, email address) information at account creation through MervCF Limited’s user onboarding portal;


                        </li>
                        <li className={classes.sizee}>Monitoring the risk profile associated with the underlying cryptocurrency wallet used to fund the user’s account;


                        </li>
                        <li className={classes.sizee}>Maintaining records of the information used to identify the user; and


                        </li>
                        <li className={classes.sizee}>Determining if a user appears on any list of known or suspected terrorists or terrorist organisations provided to the financial institutions based on the above information.


                        </li>
                      </ul>
                      <p className={classes.sizee}>
                        The above steps are operationalised using the following measures:

                      </p>
                      <ul>
                        <li className={classes.sizee}>Identity and Age Verification. A third-party service provider will support’s MervCF Limited’s ability to determine the legitimacy of the identification information other KYC materials or information provided and will confirm that the user is permissible. The service provider also will confirm that the user does not appear to be located in a comprehensively-sanctioned or otherwise prohibited jurisdiction and will search global sanctions lists to confirm that the user does not appear thereon using onboarding information such as wallet addresses.


                        </li>
                        <li className={classes.sizee}>Customer Information. MervCF Limited will collect details on each user to form a reasonable belief that MervCF Limited knows the identity of its users commensurate with the user’s risk profile. For instance, MervCF Limited may collect such details as the wallet address, name, address, country, date of birth, or postal code (collectively, “KYC Information”). MervCF Limited will collect any of the above KYC Information prior to issuing a MervCF Limited funding address (e.g., QR code) to users. MervCF Limited does not presently allow users who are non-natural persons.MervCF Limited may, at its own description rely on the performance by another institution of some or all of the elements of our CIP.



                        </li>
                        <li className={classes.sizee}>Geo-blocking for Prohibited Jurisdictions. MervCF Limited will require contractual client certifications that, through IP address-based geo-blocking, no gaming services will be offered in countries where such activity is not permitted.



                        </li>
                        <li className={classes.sizee}>Geo-blocking for Sanctioned Jurisdictions. MervCF Limited also will require contractual client certifications that such users are not subject to United States, European Union, or other global sanctions or watch lists, including individuals or entities associated with the United States’ comprehensively sanctioned jurisdictions, Iran, Cuba, North Korea, Syria and the Crimean region of Ukraine. MervCF Limited will rely on various risk-based measures to verify these representations including as in the below-described know-your-user (“KYC”) measures and through IP address-based geo-blocking.


                        </li>
                        <li className={classes.sizee}>Contractual Prohibitions on Users Onboarding from Prohibited Jurisdictions. Users are notified at onboarding that MervCF Limited does not offer services in restricted jurisdictions. MervCF Limited’s policy on restricting user activity stems from a combination of its risk, fraud prevention, and AML standards, as well as any assessments associated with the permissibility of its services in certain jurisdictions.



                        </li>
                      </ul>
                      <p className={classes.sizee}>
                        B. Enhanced Due Diligence and Ongoing Monitoring


                      </p>
                      <p className={classes.sizee}>
                        MervCF Limited performs ongoing monitoring on its users in order to detect any behaviours or indicators that might raise suspicions in regard to money laundering and terrorism financing practices. For that purpose, MervCF Limited has implemented a set of red flag indicators that help it determine such behaviours and require further action from MervCF Limited in assessing the customer information.
                        Whenever one of those red flags is triggered, the user account will be suspended and MervCF Limited will pursue enhanced due diligence. Enhanced KYC diligence under this policy is deemed to include, but not limit to, the provision of:



                      </p>
                      <ul>
                        <li className={classes.sizee}>Full legal name;



                        </li>
                        <li className={classes.sizee}>Country of citizenship;



                        </li>
                        <li className={classes.sizee}>Permanent Address (which, for an individual, must be a residential or business street address, and for an entity, must be a principal place of business, local office or other physical location);


                        </li>
                        <li className={classes.sizee}>Identification number (either a taxpayer identification number, or, if unavailable, a passport number and country of issuance, alien identification card number or number and country of issuance of another government-issued document evidencing nationality or residence and bearing a photograph or similar safeguard);



                        </li>
                        <li className={classes.sizee}>Identification Document; and



                        </li>
                        <li className={classes.sizee}>Source of Funds and Source of Wealth.



                        </li>
                      </ul>
                      <p className={classes.sizee}>
                        MervCF Limited may use third party service provider to verify any of the above information as determined to establish a reasonable basis to know the true identity of the user where the user’s activity warrants such action.


                      </p>
                      <p className={classes.sizee}>
                        C. Acceptance Policy



                      </p>
                      <p className={classes.sizee}>
                        MervCF Limited will not accept a and will block the users that:




                      </p>
                      <ul>
                        <li className={classes.sizee}>Do not provide the identification information requested by MervCF Limited;



                        </li>
                        <li className={classes.sizee}>Provide fake identification documents;




                        </li>
                        <li className={classes.sizee}>Try to use different means to deceive about their location;



                        </li>
                        <li className={classes.sizee}>Are from restricted or prohibited jurisdictions; or



                        </li>
                        <li className={classes.sizee}>Are subjected to United States, European Union, or other global sanctions or watch lists;




                        </li>
                        <li className={classes.sizee}>Are gambling addicted or have mental health issues;




                        </li>
                        <li className={classes.sizee}>Its source of funds are originated or exchanges in restricted jurisdictions;





                        </li>

                      </ul>
                      <p className={classes.sizee}>
                        MervCF Limited reserves the right to block and suspend player for any other reasons at its own description





                      </p>
                      <h2 className={classes.sizee}>Transactions Monitoring
                      </h2>
                      <p className={classes.sizee}>
                        MervCF Limited is firmly committed to complying with economic and trade sanctions programs imposed by jurisdictions in which the firm conducts business. For that purpose MervCF Limited established a transaction monitoring program with controls and processes to identify and detect any unusual activity in real time and in its ongoing monitoring.



                      </p>
                      <p className={classes.sizee}>
                        MervCF Limited will conduct ongoing monitoring on a regular basis using rule-based systems developed in-house and others from third-party vendors to review user history and patterns of activity to detect and report any unusual activity as required and to develop and implement any additional controls or limits in its platform.



                      </p>
                      <p className={classes.sizee}>
                        MervCF Limited implemented procedures addressing the following two key components of unusual or suspicious activity management:



                      </p>
                      <ul>
                        <li className={classes.sizee}>identification of unusual activity through methods of identification may include employee and customer identification, law enforcement inquiries, other referrals, or transaction and surveillance monitoring system reports; and




                        </li>
                        <li className={classes.sizee}>alert management that focuses on processes used to investigate, evaluate and document identified unusual or potentially suspicious activity.





                        </li>


                      </ul>
                      <p className={classes.sizee}>
                        MervCF Limited will use the following processes to achieve both goals:



                      </p>
                      <ul>
                        <li className={classes.sizee}>Transaction Monitoring for Sanctioned or Prohibited Jurisdictions. MervCF Limited may in its reasonable discretion impose certain due diligence requests at user balance withdrawal. MervCF Limited presently conducts a mixture of manual and automated transaction monitoring processes to identify “red flag” behaviour. Where such red flag behaviour is identified, MervCF Limited may refuse to process any withdrawal attempts or collect additional information from the recipient. MervCF Limited will further endeavour to limit any attempted user account funding from prohibited jurisdictions (which are identified in the MervCF Limited user facing disclosures and updated from time to time internally) where the associated wallet address indicates that the user or the user’s funds are located in such a prohibited jurisdiction. For instance, MervCF Limited may prohibit a user from funding their MervCF Limited account using a known U.S. based exchange wallet as such assets indicate that the user is a U.S. person. Users will have the ability to rebut any suspension with additional information as part of MervCF Limited’s ongoing transaction monitoring and user due diligence standards.





                        </li>
                        <li className={classes.sizee}>Screening for Sanctioned Parties. Prior to issuing a MervCF Limited funding address to a user, MervCF Limited will screen a user’s wallet address against applicable sanctions databases. Such screening measures will rely on third party blockchain forensics vendors such as Chainalysis. MervCF Limited will periodically re-screen wallet addresses against such databases.






                        </li>
                        <li className={classes.sizee}>Identification of Unusual Activity. MervCF Limited will monitor account activity for unusual size, volume, pattern or type of transactions, taking into account risk factors and red flags that are appropriate to its business. Monitoring will be conducted running regular reports of unusual, high risk, or suspicious user activity.







                        </li>
                        <li className={classes.sizee}>Anti-Mixing Measures.MervCF Limited will utilise software designed to detect other suspicious deposit or withdrawal patterns. Such instances will be dealt with on a case-by-case basis, depending on the perceived level of risk. In such instances, a user may be required to explain their methodology and purpose for using the platform.







                        </li>
                        <li className={classes.sizee}>Chainalysis Review. Every single crypto deposit or withdrawal both indirect and direct will run through Chainalysis and reviewed for signs of fraud or suspicious behaviour. A user’s account will be suspended and reviewed upon alert of potential illicit behaviour. Sufficient proof of wealth may be requested from high-risk accounts. MervCF Limited may refuse to withdraw to certain “high-risk” addresses as determined in consultation with Chainalysis risk scoring.







                        </li>
                        <li className={classes.sizee}>Withdrawal Threshold KYC. Additionally, and independently, every account, wherever or with whomever associated, will be suspended until adequate KYC diligence occurs once that account reaches a withdrawal threshold dependent on the accounts risk characterisation over the life of the account.








                        </li>

                      </ul>
                       <p className={classes.sizee}>
                      D. Other Ongoing Monitoring Controls



                      </p>
                      <p className={classes.sizee}>
                      Additionally to the above mentioned controlling procedures, MervCF Limited has also implemented the following procedures to complement its know your customer and ongoing monitoring procedures:




                      </p>
                       <ul>
                        <li className={classes.sizee}>Ban Evasion Detection. In addition, MervCF Limited will utilise third-party service provider software designed to detect the use by one user of multiple accounts. This software relies on detection of links between the same devices used to access multiple accounts. Such instances will be dealt with on a case-by-case basis, depending on the perceived level of risk. In such instances, a user may be required to explain their methodology and purpose for using the platform. MervCF Limited accounts are funded by users using local (non-custodial) or hosted (custodial) wallets. In addition to a Chainalysis screening, MervCF Limited monitors user activity within the MervCF Limited platform and any withdrawals must meet MervCF Limited’s and its third-party service provider’s verification processes. MervCF Limited further prohibits peer-to-peer account transfers within the MervCF Limited platform infrastructure. Any attempts to circumvent this restriction will be treated as a red flag.





                        </li>
                        <li className={classes.sizee}>Time Zone Monitoring. MervCF Limited has implemented time zone controls that detects the users device information and crosses it with restricted jurisdiction to understand if they are trying to use geo location software to hide the jurisdictions where they are connecting from.





                        </li>
                        <li className={classes.sizee}>Products and Services Review. MervCF Limited will establish additional procedures to avoid facilitating user attempts to exploit the MervCF Limited platform. MervCF Limited has a robust set of user-facing terms that users attest to in order to utilise the MervCF Limited platform. MervCF Limited will establish certain additional safeguards to mitigate against the risk of such misuse. For instance, MervCF Limited may establish policies or procedures for limiting which user assets can be onboarded to the MervCF Limited platform. MervCF Limited lists the assets that are available for use on the MervCF Limited platform. MervCF Limited does not allow the use of anonymity enhancing technologies such as mixers, tumblers, or certain coins and tokens. Where MervCF Limited becomes aware that an anonymity enhancing technology is being used on the MervCF Limited platform, MervCF Limited will disallow such use.




                        </li>
                        <li className={classes.sizee}>Vendor Management. MervCF Limited works with reputable third-party service providers as part of its compliance infrastructure. MervCF Limited will periodically assess the strength of its key third party service providers to determine if additional services are needed, the third-party service provider is not performing consistent with its contractual obligations, or if other remedial action is necessary for MervCF Limited to comply with this policy. MervCF Limited may request information from any third-party service provider as part of its vendor review process.





                        </li>
                          <li className={classes.sizee}>Compliance Innovation. In addition to vendor management, MervCF Limited will continuously monitor any non documentary compliance mechanisms to determine their viability for the MervCF Limited program. MervCF Limited may run test or trial programs on a limited basis with such compliance vendors to determine the effectiveness of such programs. Blockchain native compliance tools include fraud prevention services, on-chain KYC providers, and other tools designed to reflect the technological features associated with blockchain platforms.






                        </li>


                      </ul>
                        <h2 className={classes.sizee}>6. Education and Training

                      </h2>
                       <p className={classes.sizee}>
                     MervCF Limited, with the assistance of its legal counsel and under the oversight of its CCO, may provide employees AML, anti-terrorist financing and trade sanctions compliance training on a periodic basis, as deemed appropriate.



                      </p>
                       <h2 className={classes.sizee}>7. Reporting


                      </h2>
                       <p className={classes.sizee}>
                    MervCF Limited is obliged to report any unusual or suspicious transactions, in accordance with the National Ordinance. Customers that are identified as being on a sanctions list, linked to money laundering or terrorism financing or other criminal activities will be reported as suspicious activity to the regulator



                      </p>
                    </div>

                  </Box>
                </Card>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
      <Footer />
    </>
  );
}
